import to from 'await-to-js';
import router from '../../router/';
import AuthService from '../../services/Auth';
import { EventBus } from "../event-bus";

function initialState() {
  return {
    data: {
      token: '',
      role: ''
    }
  };
}

export default {
  initialState,
  namespaced: true,
  state: initialState(),
  getters: {
  },
  actions: {
    /**
     * Login user to the Morpher. Manipulation user data possible. Setting user in the index(l-207).
     * @param commit
     * @param state
     * @param dispatch
     * @param params
     * @returns {Promise<*>}
     */
    async login({ commit, state, dispatch }, params) {
      let [err, response] = await to(AuthService.login(params));
      if(err) {
        EventBus.$emit('resetLogin');
        return this._vm.errorSnack(err);
      }
      commit('account', {
        token: response.data.token,
        ...response.data.data
      });
      localStorage.setItem('CompanyId', state.data.CompanyId);
      localStorage.setItem('token', state.data.token);
      localStorage.setItem('role', state.data.role);

      location.href = '/' + state.data.role + '/';
    },
  },
  mutations: {
    account(state, data){
      state.data = data;
    }
  }
};
